import moment from 'moment';
import angular from 'angular';
import * as R from 'ramda';

export default function EditFindingDialogController(
  $q,
  $rootScope,
  $scope,
  $timeout,
  alerts,
  amDataService,
  amSharedModelService,
  loaderService,
  saveFindingConfirmDialog,
  ssDialogService
) {
  const vm = this;

  vm.handleCloseDialog = handleCloseDialog;
  vm.handleFormSubmit = handleFormSubmit;
  vm.handleNameChange = handleNameChange;
  vm.handleAssignmentChange = handleAssignmentChange;
  vm.handleStatusChange = handleStatusChange;
  vm.handleRepeatFindingChange = handleRepeatFindingChange;
  vm.handlePriorityChange = handlePriorityChange;
  vm.newFinding = { ...vm.finding };

  vm.nameIsValid = true;

  _activate();

  /** *********************************************
   * Event Handlers
   */

  function handleCloseDialog() {
    return _closeDialog();
  }

  function handleFormSubmit($event) {
    if ($scope.editAMFindingForm.$invalid) {
      return Promise.resolve();
    }
    if (!_isValid(true)) {
      // Set the form as unsubmitted since the user needs to make changes
      $scope.editAMFindingForm.$setPristine();
      $scope.editAMFindingForm.$setUntouched();
      return Promise.resolve();
    }
    _formatFindingInputData();
    if ((vm.findingsDefaultDueDate !== null) && (vm.dueDate > vm.findingsDefaultDueDate)) {
      return _openSaveFindingConfirmation($event);
    }
    const isNew = vm.newFinding.findingId <= 0;

    if (!isNew && angular.equals(vm.finding, vm.newFinding)) {
      // No need to save
      return _closeDialog();
    }
    loaderService.showViewLoader = true;
    return amSharedModelService.saveFinding(vm.newFinding).then((savedFinding) => {
      angular.extend(vm.newFinding, savedFinding);
      angular.extend(vm.finding, vm.newFinding);
      if (isNew) {
        vm.addCallback(vm.finding);
        $rootScope.$broadcast('refreshAMFindings', { findingCategoryId: vm.finding.findingCategoryId });
        $rootScope.$broadcast('refreshNotifications');
      }
      return _closeDialog().then(() => {
        $rootScope.$broadcast('refreshAMFindings', { findingCategoryId: vm.finding.findingCategoryId });
        // $rootScope.$broadcast('refreshAMFinding', { findingId: vm.finding.findingId });
        alerts.success('The finding has been saved successfully.');
        $rootScope.$broadcast('refreshNotifications');
      });
    })
    .catch(() => {
      alerts.error('An error occurred while saving the finding.');
    })
    .finally(() => {
      loaderService.showViewLoader = false;
    });
  }

  /**
   * Sync is repeat finding and priority
   */
  function handleRepeatFindingChange() {
    if (vm.newFinding.isRepeatFinding) { // Is a repeat finding
      vm.newFinding.priorityId = 3; // High Priority
    } else {
      vm.newFinding.priorityId = vm.finding.priorityId;
    }
  }

  /**
   * Sync is repeat finding and priority
   */
  function handlePriorityChange() {
    if (vm.newFinding.priorityId !== 3) { // High
      vm.newFinding.isRepeatFinding = false;
    }
  }

  /**
   * Sync statusId and assignedToUser to assignedToUserId
   */
  function handleAssignmentChange() {
    vm.newFinding.assignedToUserId = vm.newFinding.assignedToUser.userId;
    if ((vm.newFinding.statusId !== 3) && (vm.newFinding.statusId !== 4)) { // Completed, Completed Risk Accepted
      if (vm.newFinding.assignedToUserId > 0) {
        vm.newFinding.statusId = 2; // Assigned
      } else {
        vm.newFinding.statusId = 1; // Unassigned
      }
    }
  }

  function handleNameChange() {
    const dfdSave = $q.defer();

    if (_isNameValid()) {
      amSharedModelService.checkFindingNameExists(
        vm.newFinding.findingCategoryId,
        vm.newFinding.findingId,
        vm.newFinding.name
      ).then((nameExists) => {
        if (nameExists) {
          alerts.error('The Finding Name exists already. Please choose a different name.');
          vm.nameIsValid = false;
          dfdSave.reject();
        } else {
          vm.nameIsValid = true;
          dfdSave.resolve();
        }
      });
    } else {
      vm.nameIsValid = false;
      dfdSave.reject();
    }

    return dfdSave.promise;
  }

  function handleStatusChange() {
    if (vm.newFinding.statusId === 1) { // Unassigned
      vm.completedDate = null;
      vm.newFinding.completedDate = null;
      vm.newFinding.assignedToUserId = -1;
    } else if (vm.newFinding.statusId === 2) { // Assigned
      vm.completedDate = null;
      vm.newFinding.completedDate = null;
      if (vm.newFinding.assignedToUserId > 0) {
        // Don't do anything. There is an assignment already
      } else {
        alerts.error('You cannot change the status to assigned. '
          + 'Please change the assigned user to update to the assigned status.');
        vm.newFinding.statusId = 1; // Unassigned
      }
    } else if (vm.newFinding.statusId === 3) { // Completed
      vm.completedDate = moment();
      vm.newFinding.completedDate = moment(vm.completedDate).format('MM/DD/YYYY');
    } else if (vm.newFinding.statusId === 4) { // Completed - Risk Accepted
      vm.completedDate = moment();
      vm.newFinding.completedDate = moment(vm.completedDate).format('MM/DD/YYYY');
    }
  }

  /** *********************************************
   * Private Functions
   */

  function _activate() {
    // Set Default Values
    if (R.isNil(vm.newFinding.assignedToUserId)) { vm.newFinding.assignedToUserId = -1; }
    if (R.isNil(vm.newFinding.businessRiskId)) { vm.newFinding.businessRiskId = -1; }
    if (R.isNil(vm.newFinding.technicalRiskId)) { vm.newFinding.technicalRiskId = -1; }
    if (R.isNil(vm.newFinding.priorityId)) { vm.newFinding.priorityId = -1; }
    if (!R.isNil(vm.newFinding.dueDate)) { vm.dueDate = moment(vm.newFinding.dueDate); }
    if (!R.isNil(vm.newFinding.completedDate)) { vm.completedDate = moment(vm.newFinding.completedDate); }
    if (!R.isNil(vm.newFinding.customDate1)) { vm.customDate1 = moment(vm.newFinding.customDate1); }
    if (!R.isNil(vm.newFinding.customDate2)) { vm.customDate2 = moment(vm.newFinding.customDate2); }
    if (!R.isNil(vm.newFinding.customDate3)) { vm.customDate3 = moment(vm.newFinding.customDate3); }
    if (!R.isNil(vm.newFinding.customDate4)) { vm.customDate4 = moment(vm.newFinding.customDate4); }
    if (!R.isNil(vm.newFinding.customDate5)) { vm.customDate5 = moment(vm.newFinding.customDate5); }
    vm.contentPaneIsFaded = false;
    vm.currentFindingId = 0;

    _initEventListeners();

    loaderService.showViewLoader = true;
    _refreshBusinessRisks().then(
      _refreshTechnicalRisks().then(
        amDataService.getBaseAudit(vm.auditId).then((response) => {
          loaderService.showViewLoader = false;
          const fddd = response.data.findingsDefaultDueDate;
          if (fddd !== null) { vm.findingsDefaultDueDate = moment(fddd); }
        })
      )
    );
  }

  function _initEventListeners() {
    $scope.$on('refreshAMBusinessRisks', _refreshBusinessRisks);
    $scope.$on('refreshAMTechnicalRisks', _refreshTechnicalRisks);
    $scope.$on('refreshAMPriorities', _refreshPriorities);
  }

  function _formatFindingInputData() {
    vm.newFinding.dueDate = formatDate(vm.dueDate, vm.newFinding.dueDate);
    vm.newFinding.completedDate = formatDate(vm.completedDate, vm.newFinding.completedDate);
    vm.newFinding.customDate1 = formatDate(vm.customDate1, vm.newFinding.customDate1);
    vm.newFinding.customDate2 = formatDate(vm.customDate2, vm.newFinding.customDate2);
    vm.newFinding.customDate3 = formatDate(vm.customDate3, vm.newFinding.customDate3);
    vm.newFinding.customDate4 = formatDate(vm.customDate4, vm.newFinding.customDate4);
    vm.newFinding.customDate5 = formatDate(vm.customDate5, vm.newFinding.customDate5);
    vm.newFinding.assignedToUserId = getDefaultedId(vm.newFinding.assignedToUserId);
    vm.newFinding.businessRiskId = getDefaultedId(vm.newFinding.businessRiskId);
    vm.newFinding.technicalRiskId = getDefaultedId(vm.newFinding.technicalRiskId);
    vm.newFinding.priorityId = getDefaultedId(vm.newFinding.priorityId);

    function formatDate(vmDate) {
      if (!R.isNil(vmDate)) {
        return moment(vmDate).format('MM/DD/YYYY');
      }
      return null;
    }

    function getDefaultedId(id) {
      return id === -1 ? null : id;
    }
  }

  function _refreshBusinessRisks() {
    const dfdRefresh = $q.defer();
    vm.businessRisks = amSharedModelService.businessRisks;
    dfdRefresh.resolve();
    return dfdRefresh.promise;
  }

  function _refreshTechnicalRisks() {
    const dfdRefresh = $q.defer();
    vm.technicalRisks = amSharedModelService.technicalRisks;
    dfdRefresh.resolve();
    return dfdRefresh.promise;
  }

  function _refreshPriorities() {
    const dfdRefresh = $q.defer();
    vm.priorities = amSharedModelService.priorities;
    dfdRefresh.resolve();
    return dfdRefresh.promise;
  }

  function _isValid(checkName) {
    let isValid = true;

    angular.forEach($scope.editAMFindingForm.$error.pattern, () => {
      isValid = false;
    });
    angular.forEach($scope.editAMFindingForm.$error.required, () => {
      isValid = false;
    });

    if (isValid) {
      isValid = _areDatesValid();
    }

    if (isValid) {
      if (!_hasBothAssignedUserAndDueDateOrNeither()) {
        alerts.error('If the Due Date or Assigned User is entered, then both must be set in the Finding.');
        isValid = false;
      }
    }

    if (isValid && checkName) {
      if (!vm.nameIsValid) {
        alerts.error('There is an issue with the Finding Name.');
        isValid = false;
      }
    }

    return isValid;
  }

  function _areDatesValid() {
    let isValid = true;
    angular.forEach($scope.editAMFindingForm.$error.parse, (item) => {
      if ((item.$name === 'editFindingCompletedDate')
        || (item.$name === 'editFindingDueDate')
        || (item.$name === 'editFindingCustomDate1')
        || (item.$name === 'editFindingCustomDate2')
        || (item.$name === 'editFindingCustomDate3')
        || (item.$name === 'editFindingCustomDate4')
        || (item.$name === 'editFindingCustomDate5')) {
        if (!R.isNil(item.$modelValue) && (!moment(item.$modelValue).isValid())) {
          isValid = false;
        }
      } else {
        isValid = false;
      }
    });
    return isValid;
  }

  function _isNameValid() {
    let isValid = true;

    if (!vm.nameIsValid) {
      alerts.error('There is an issue with the Finding Name.');
      isValid = false;
    }

    return isValid;
  }

  function _hasBothAssignedUserAndDueDateOrNeither() {
    // Is assigned to user
    const a = vm.newFinding.assignedToUserId && vm.newFinding.assignedToUserId > -1;
    // Has a due date
    const b = !!vm.dueDate;

    if (a || b) return a && b; // has both?
    return true; // has neither
  }

  function _openSaveFindingConfirmation($event) {
    loaderService.showViewLoader = true;
    ssDialogService.dialogs.auditTrail.saveFindingConfirmDialog = ssDialogService.alert(
      saveFindingConfirmDialog.getOptions($event, {
        customerId: vm.customerId,
        auditId: vm.auditId,
        statuses: vm.statuses,
        businessRisks: vm.businessRisks,
        technicalRisks: vm.technicalRisks,
        priorities: vm.priorities,
        users: vm.users,
        finding: vm.newFinding,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.auditTrail.saveFindingConfirmDialog);
    ssDialogService.hide(ssDialogService.dialogs.auditTrail.editFindingDialog);
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.auditTrail.editFindingDialog);
  }
}

EditFindingDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  '$timeout',
  'alerts',
  'amDataService',
  'amSharedModelService',
  'loaderService',
  'saveFindingConfirmDialog',
  'ssDialogService'
];
